import {
  AgentRoleType,
  AgentRoleTypeValue,
  ProposalDocGenerationStatus,
  ProposalStatus,
  QuoteStatus,
} from 'Quoting/models/enum';
import {VALUE_NOT_AVAILABLE} from './utilities';

import {A360ProductModel, A360Product, A360ProductCd} from 'Quoting/models/Quoting';
import {OpportunityQuote} from 'Quoting/models/DTOs/Opportunity';

export const getProductNameFromModel = (model: A360ProductModel) => {
  switch (model) {
    case A360ProductModel.HIMaster:
      return A360Product.HospitalIndemnity;

    case A360ProductModel.CIMaster:
      return A360Product.CriticalIllness;

    case A360ProductModel.ACCMaster:
      return A360Product.Accident;

    case A360ProductModel.GPLUMaster:
      return A360Product.GroupWholeLife;

    default:
      return VALUE_NOT_AVAILABLE;
  }
};

export const getProductCdFromModel = (model: A360ProductModel) => {
  switch (model) {
    case A360ProductModel.ACCMaster:
      return A360ProductCd.ACC;

    case A360ProductModel.CIMaster:
      return A360ProductCd.CI;

    case A360ProductModel.HIMaster:
      return A360ProductCd.HI;

    case A360ProductModel.GPLUMaster:
      return A360ProductCd.GPLU;

    default:
      return VALUE_NOT_AVAILABLE;
  }
};

export const getDocStatus = (status: string | null): string | null => {
  if (!status) return 'Not Requested Yet';
  switch (status) {
    case ProposalDocGenerationStatus.Complete:
      return 'Complete';
    case ProposalDocGenerationStatus.Failed:
      return 'Failed';
    case ProposalDocGenerationStatus.Generating:
      return 'Generating';
    default:
      return 'Not Requested Yet';
  }
};

export const getProposalStatus = (status: string | null): string | null => {
  if (!status) return null;
  switch (status) {
    case ProposalStatus.IN_PROGRESS:
      return 'In Progress';
    case ProposalStatus.GENERATED:
      return 'Generated';
    case ProposalStatus.SOLD:
      return 'Sold';
    default:
      return null;
  }
};

export const quoteStatusLabelMapping: Record<QuoteStatus, string> = {
  contractAccepted: 'Sold',
  companyDeclined: 'Declined by SIC',
  customerDeclined: 'Declined by Broker/Group',
  dataGather: 'Data Gathering',
  initialized: 'Initiated',
  rated: 'Premium Calculated',
  readyForProposal: 'Ready For Proposal',
  proposed: 'Proposed',
  inUnderwritingReview: 'In Underwriting Review',
  sold: 'Sold',
  uwDeclined: 'UW Declined',
  premiumCalculated: 'Premium Calculated',
  allStatus: 'All Status',
};
